import {
  buildAttachmentReferences,
  buildEmailList
} from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.utils';
import { EMAIL_DETAILS_FORM_FIELDS_MAP } from 'features/sendouts/components/forms/EmailDetails/EmailDetails.fields';
import { getSelectedReasonIds } from 'features/sendouts/components/forms/SendoverReasonsFields';

export const SENDOVER_TEMPLATE_ID = 4;

export const FORM_FIELDS_MAP = {
  ...EMAIL_DETAILS_FORM_FIELDS_MAP,
  CandidateRecruiter: { key: 'candidateRecruiter' },
  SendoverReasons: { key: 'sendoverReasons' },
  Comments: { key: 'comments' },
  AutomaticReminder: { key: 'automaticReminder' },
  Attachments: { key: 'attachments' }
};

const buildReasonDetails = (_, formValues = {}) => ({
  reasonIds: getSelectedReasonIds(formValues[FORM_FIELDS_MAP.SendoverReasons.key]),
  notes: formValues[FORM_FIELDS_MAP.Comments.key] || ''
});

export const SENDOVER_CREATION_FIELDS_MAP = {
  AccountableRecruiter: {
    key: FORM_FIELDS_MAP.AccountableRecruiter.key,
    paramKey: 'jobOrderAccountableId',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: FORM_FIELDS_MAP.CandidateRecruiter.key,
    paramKey: 'candidateAccountableId',
    outboundAccesor: 'id'
  },
  Candidate: {
    key: FORM_FIELDS_MAP.Candidate.key,
    paramKey: 'candidateId',
    outboundAccesor: 'id'
  },
  HiringAuthority: {
    key: FORM_FIELDS_MAP.HiringAuthority.key,
    paramKey: 'hiringAuthorityId',
    outboundAccesor: 'id'
  },
  Attachments: {
    key: FORM_FIELDS_MAP.Attachments.key,
    paramKey: 'attachments',
    outboundAccesor: buildAttachmentReferences
  },
  ReasonDetails: {
    key: FORM_FIELDS_MAP.SendoverReasons.key,
    paramKey: 'reasonDetails',
    outboundAccesor: buildReasonDetails
  }
};

export const SENDOVER_CREATION_EMAIL_FIELDS_MAP = {
  CarbonCopy: {
    key: FORM_FIELDS_MAP.CarbonCopy.key,
    paramKey: 'ccEmails',
    outboundAccesor: buildEmailList
  },
  BlindCarbonCopy: {
    key: FORM_FIELDS_MAP.BlindCarbonCopy.key,
    paramKey: 'bccEmails',
    outboundAccesor: buildEmailList
  },
  EmailSubject: {
    key: FORM_FIELDS_MAP.EmailSubject.key,
    paramKey: 'subject'
  },
  EmailBody: {
    key: FORM_FIELDS_MAP.EmailBody.key,
    paramKey: 'body'
  }
};
